(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("dayjs"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash", "dayjs"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("lodash"), require("dayjs")) : factory(root["lodash"], root["dayjs"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_19__, __WEBPACK_EXTERNAL_MODULE_73__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 91);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(25)('wks');
var uid = __webpack_require__(14);
var Symbol = __webpack_require__(0).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 2 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 3 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(10)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(6);
var createDesc = __webpack_require__(13);
module.exports = __webpack_require__(4) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var IE8_DOM_DEFINE = __webpack_require__(34);
var toPrimitive = __webpack_require__(27);
var dP = Object.defineProperty;

exports.f = __webpack_require__(4) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(57);
var defined = __webpack_require__(21);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var core = __webpack_require__(2);
var ctx = __webpack_require__(32);
var hide = __webpack_require__(5);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(39);
var enumBugKeys = __webpack_require__(22);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(6).f;
var has = __webpack_require__(3);
var TAG = __webpack_require__(1)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_19__;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(42);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.date = date;
exports.number = number;
exports.search2obj = search2obj;
exports.obj2search = obj2search;
exports.camel2underline = camel2underline;
exports.middle2underline = middle2underline;
exports.imgPostfix = imgPostfix;
exports.protocolFixer = protocolFixer;
exports.staticFilePath = staticFilePath;

var _dayjs = __webpack_require__(73);

var _dayjs2 = _interopRequireDefault(_dayjs);

var _lodash = __webpack_require__(19);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function date(date, format) {
  format = format || 'YYYY-MM-DD';

  return (0, _dayjs2.default)(date).format(format);
}

function number(number) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  if (typeof number == 'number' && number.toFixed && !isNaN(number)) {
    return number.toFixed(length);
  }
  if (typeof number == 'string' && (parseInt(number) == number || parseFloat(number) == number)) {
    return parseFloat(number).toFixed(length);
  }
  return '';
}

function search2obj() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _arr,
      _obj = {};

  if ((typeof str === 'undefined' ? 'undefined' : (0, _typeof3.default)(str)) == 'object') return str;

  if (typeof str !== 'string') return _obj;

  var searchString = str.split('?')[1] || str || '';

  if (searchString) {
    _arr = searchString.split('&');
  }

  _lodash2.default.forEach(_arr, function (item) {
    var tempArr = item.split('=');
    if (!tempArr[0] || !tempArr[1]) return;
    _obj[tempArr[0]] = decodeURIComponent(tempArr[1]);
  });

  return _obj;
}

function obj2search(obj) {
  if (typeof obj == 'string') return obj;

  var _arr = [];

  _lodash2.default.forEach(obj, function (value, key) {
    if (!key || (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) == 'object' || !value && value !== 0) return;
    _arr.push(camel2underline(key) + '=' + encodeURIComponent(value));
  });

  return _arr.join('&');
}

function camel2underline(str) {
  var reg = /([A-Z])/g;
  return str.replace(reg, function (s0, s1) {
    return '_' + s1.toLowerCase();
  });
}

function middle2underline(str) {
  return str.replace(/([a-zA-Z0-9])-([a-zA-Z0-9])/g, '$1_$2');
}

function imgPostfix(url, postfix, divider) {
  var _defaultDivider = '!';

  divider = divider || _defaultDivider;

  if (!url || !url.match(/zoneke-img/)) return url;

  if (url.indexOf(divider) === -1) {
    return url + divider + postfix;
  } else {
    var reg = new RegExp(divider + '\[0-9a-z\]\*');
    return url.replace(reg, '!' + postfix);
  }
}

function protocolFixer(url) {
  var protocol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!url) {
    return '';
  }
  var protocolReg = new RegExp(/^(http:|https:)/);
  return url.replace(protocolReg, protocol);
}

function staticFilePath(url, postfix) {
  if (!url) return '';

  var MAP_STR = {
    'http://': '//',
    'zoneke-img.b0.upaiyun.com': 'img.qingchengfit.cn',
    'qcfile.b0.upaiyun.com': 'static.qingchengfit.cn'
  };

  var postReg = /![0-9a-z]*$/;

  var divider = '!';

  var qcImgReg = /img\.qingchengfit\.cn/;

  var reg = new RegExp('(http://|zoneke-img.b0.upaiyun.com|qcfile.b0.upaiyun.com)', 'g');

  url = url.replace(reg, function ($0, $1) {
    return MAP_STR[$1];
  });

  if (!url.match(qcImgReg)) return url.replace(postReg, '');

  if (url.indexOf('!') === -1 && postfix) return url + divider + postfix;

  if (postfix) return url.replace(postReg, divider + postfix);

  return url;
}

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 23 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(25)('keys');
var uid = __webpack_require__(14);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(9);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var core = __webpack_require__(2);
var LIBRARY = __webpack_require__(16);
var wksExt = __webpack_require__(29);
var defineProperty = __webpack_require__(6).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(1);


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var platform = {};

var APP_REG_MAP = {
  staff: /FitnessTrainerAssistant\/(\d+(?:\.\d+){0,2}).+Staff/i,
  coach: /FitnessTrainerAssistant\/(\d+(?:\.\d+){0,2})(?!.+Staff)/i,
  wx: /MicroMessenger\//i,
  alipay: /AlipayClient\//i,
  chrome: /chrome/i,
  safari: /safari/i
};

var ENV_REG_MAP = {
  staffDev: /OEM:staff-test/,
  coachDev: /OEM:coach-test/
};

var SYSTEM_REG_MAP = {
  android: /android/i,
  iOS: /iPhone\sOS\s(\d+)\D/i
};

function getApp(userAgent) {
  var result;
  for (var key in APP_REG_MAP) {
    if (APP_REG_MAP.hasOwnProperty(key)) {
      result = userAgent.match(APP_REG_MAP[key]);
      if (result) {
        platform.app = key;
        if (key === 'staff' || key === 'coach') {
          platform.qcAppVersion = result[1];
          platform.inQcApp = !0;
        }
        return;
      }
    }
  }
}

function getSystem(userAgent) {
  var result;
  for (var key in SYSTEM_REG_MAP) {
    if (SYSTEM_REG_MAP.hasOwnProperty(key)) {
      result = userAgent.match(SYSTEM_REG_MAP[key]);
      if (result) {
        platform.system = key;
        if (key === 'iOS') {
          platform.iOSVersion = result[1];
        }
        return;
      }
    }
  }
}

function getEnv(userAgent) {
  var result;
  platform.env = platform.system ? platform.app + 'Prod' : '';

  for (var key in ENV_REG_MAP) {
    if (ENV_REG_MAP.hasOwnProperty(key)) {
      result = userAgent.match(ENV_REG_MAP[key]);
      if (result) {
        platform.env = key;
      }
      return;
    }
  }
}

if (typeof window !== 'undefined' && window.navigator.userAgent) {
  getApp(window.navigator.userAgent);
  getSystem(window.navigator.userAgent);
  getEnv(window.navigator.userAgent);
}

exports.default = platform;

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(31);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);
var document = __webpack_require__(0).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(4) && !__webpack_require__(10)(function () {
  return Object.defineProperty(__webpack_require__(33)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(16);
var $export = __webpack_require__(11);
var redefine = __webpack_require__(40);
var hide = __webpack_require__(5);
var has = __webpack_require__(3);
var Iterators = __webpack_require__(12);
var $iterCreate = __webpack_require__(59);
var setToStringTag = __webpack_require__(18);
var getPrototypeOf = __webpack_require__(66);
var ITERATOR = __webpack_require__(1)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(7);
var dPs = __webpack_require__(63);
var enumBugKeys = __webpack_require__(22);
var IE_PROTO = __webpack_require__(24)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(33)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(43).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(39);
var hiddenKeys = __webpack_require__(22).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(3);
var toIObject = __webpack_require__(8);
var arrayIndexOf = __webpack_require__(55)(false);
var IE_PROTO = __webpack_require__(24)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(5);


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(97), __esModule: true };

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(51);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(50);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(0).document;
module.exports = document && document.documentElement;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(26);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(21);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {



/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(67)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(35)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(69);
var global = __webpack_require__(0);
var hide = __webpack_require__(5);
var Iterators = __webpack_require__(12);
var TO_STRING_TAG = __webpack_require__(1)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__(42);

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = __webpack_require__(41);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(76);

var _stringify2 = _interopRequireDefault(_stringify);

var _platform_svc = __webpack_require__(30);

var _platform_svc2 = _interopRequireDefault(_platform_svc);

var _check_app_version_svc = __webpack_require__(74);

var _check_app_version_svc2 = _interopRequireDefault(_check_app_version_svc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iosMessageHandlerSinceVersion = {
    coach: '2.7.3',
    staff: '2.8.8'
};

var webLinkNativeSvc = {
    setAction: setAction,
    doPromise: doPromise,
    sensorsTrack: sensorsTrack,
    goNativePath: goNativePath,
    shareInfo: shareInfo,
    getNativeMethod: getNativeMethod,
    hasNativeMethod: hasNativeMethod,
    setTitle: setTitle,
    completeAction: completeAction,
    goBack: goBack,
    onFinishLoad: onFinishLoad,
    savePhoto: savePhoto
};

if (typeof window !== 'undefined') {
    window.nativeLinkWeb = window.nativeLinkWeb || {};
    window.nativeLinkWeb.runCallback = function (name, data) {
        window.nativeLinkWeb.callbackLst[name](data);
    };

    if (_platform_svc2.default.system == 'iOS') {
        if (checkIosBridge()) {
            handleIOSNativeMethod();
        } else {
            iOSMessageHandler();
        }
    }
}

function checkIosBridge() {
    return _check_app_version_svc2.default.isPrevVersion(_platform_svc2.default.iOSVersion, iosMessageHandlerSinceVersion[_platform_svc2.default.app]);
}

function securityTest() {
    if (_platform_svc2.default.inQcApp) {
        var isDev = _platform_svc2.default.env === 'staffDev' || _platform_svc2.default.env === 'coachDev';
        if (!isDev) {
            var host = window.location.host;
            var reg = /(\S)+\.qingchengfit\.(\w)+/;

            return reg.test(host);
        }
        return true;
    }

    return false;
}

exports.default = function () {
    var isPassedTest = securityTest();

    if (!isPassedTest) {
        console.error('该网站不能使用青橙webLinkNativeService');
        return {};
    }

    return webLinkNativeSvc;
}();

function setAction(config) {
    function _doAction() {
        if (_platform_svc2.default.system == 'iOS') {
            if (!window.NativeMethod) return setTimeout(_doAction, 100);
        }
        if (!window.NativeMethod || !window.NativeMethod.setAction) return;
        window.NativeMethod.setAction((0, _stringify2.default)({ name: config.name }));
        window.nativeLinkWeb.callbackLst = window.nativeLinkWeb.callbackLst || {};

        window.nativeLinkWeb.callbackLst.setAction = config.callback;
    }

    _doAction();
}

function doPromise(taskCfg, cbCfg) {
    if (!taskCfg || !taskCfg.name) return;

    function _doAction() {
        if (_platform_svc2.default.system == 'iOS') {
            if (!window.NativeMethod) return setTimeout(_doAction, 100);
        }
        if (window.NativeMethod && window.NativeMethod[taskCfg.name]) {
            if (taskCfg.data) {
                window.NativeMethod[taskCfg.name](typeof taskCfg.data == 'string' ? taskCfg.data : (0, _stringify2.default)(taskCfg.data));
            } else {
                window.NativeMethod[taskCfg.name]();
            }

            if (cbCfg && cbCfg.name) {
                window.nativeLinkWeb.callbackLst = window.nativeLinkWeb.callbackLst || {};

                window.nativeLinkWeb.callbackLst[cbCfg.name] = cbCfg.callback;
            }
        } else {
            throw new Error('No ' + taskCfg.name + ' method in NativeMethod or ' + taskCfg.name + ' method need update');
        }
    }

    _doAction();
}

function sensorsTrack(key, data) {
    function _doAction() {
        if (_platform_svc2.default.system == 'iOS') {
            if (!window.NativeMethod) return setTimeout(_doAction, 100);
        }
        if (!window.NativeMethod.sensorsTrack) return;
        window.NativeMethod.sensorsTrack(key, (0, _stringify2.default)(data));
    }

    _doAction();
}

function goNativePath(path) {
    var _callbackName;
    if (!path.match(/^\w+:\/\/\w+/)) {
        _callbackName = path;
        if (_platform_svc2.default.app == 'staff') path = 'qcstaff://' + path;
        if (_platform_svc2.default.app == 'coach') path = 'qccoach://' + path;
    } else {
        _callbackName = path.split('//')[1];
    }
    _callbackName = _callbackName.split('?')[0];
    return new _promise2.default(function (resolve, reject) {
        if (window.NativeMethod.goNativePath && _check_app_version_svc2.default.checkCommentFeature()) {
            window.NativeMethod.goNativePath(path);
            window.nativeLinkWeb.callbackLst = window.nativeLinkWeb.callbackLst || {};
            window.nativeLinkWeb.callbackLst[_callbackName] = function (data) {
                resolve(typeof data === 'string' ? JSON.parse(data) : data);
            };
            window.nativeLinkWeb.callbackLst['goNativePathFailed'] = function (data) {
                reject(typeof data === 'string' ? JSON.parse(data) : data);
            };
        } else {
            reject('No goNativePath method in NativeMethod or goNativePath method need update');
        }
    });
}

function shareInfo(config) {
    return new _promise2.default(function (resolve, reject) {
        if (window.NativeMethod.shareInfo) {
            window.NativeMethod.shareInfo((typeof config === 'undefined' ? 'undefined' : (0, _typeof3.default)(config)) === 'object' ? (0, _stringify2.default)(config) : config);
            window.nativeLinkWeb.callbackLst = window.nativeLinkWeb.callbackLst || {};
            window.nativeLinkWeb.callbackLst.shareInfo = function (data) {
                resolve(typeof data === 'string' ? JSON.parse(data) : data);
            };
        } else {
            reject('No shareInfo method in NativeMethod or shareInfo method need update');
        }
    });
}

function getNativeMethod() {
    return window.NativeMethod || {};
}

function hasNativeMethod() {
    return !!window.NativeMethod;
}

function setTitle(title) {
    this.doPromise({ name: 'setTitle', data: title });
}

function completeAction() {
    this.doPromise({ name: 'completeAction' });
}

function goBack() {
    this.doPromise({ name: 'goBack' });
}

function savePhoto(url) {
    this.doPromise({ name: 'savePhoto', data: { url: url } });
}

function onFinishLoad() {
    this.doPromise({ name: 'onFinishLoad' });
}

function handleIOSNativeMethod() {
    function connectWebViewJavascriptBridge(callback) {
        if (window.WebViewJavascriptBridge) {
            callback(window.WebViewJavascriptBridge);
        } else {
            document.addEventListener('WebViewJavascriptBridgeReady', function () {
                callback(window.WebViewJavascriptBridge);
            }, false);
        }
    }

    connectWebViewJavascriptBridge(function (bridge) {
        bridge.init(function (message, responseCallback) {});

        if (!window.NativeMethod) {
            window.NativeMethod = {};
        }

        window.NativeMethod.wechatPay = function (data) {
            bridge.callHandler('iOSHandler', {
                'name': 'wechatPay',
                data: {
                    data: JSON.parse(data)
                }
            }, function (response) {});
        };

        window.NativeMethod.openDrawer = function () {
            bridge.callHandler('iOSHandler', { 'name': 'openDrawer' }, function (response) {});
        };

        window.NativeMethod.getContacts = function () {
            bridge.callHandler('iOSHandler', { 'name': 'getContacts' }, function (response) {});
        };

        window.NativeMethod.openMsg = function () {
            bridge.callHandler('iOSHandler', { 'name': 'openMsg' }, function (response) {});
        };

        window.NativeMethod.completeAction = function () {
            bridge.callHandler('iOSHandler', { 'name': 'completeAction' }, function (response) {});
        };

        window.NativeMethod.shareInfo = function (_config) {
            bridge.callHandler('iOSHandler', { 'name': 'shareInfo', data: _config }, function (response) {});
        };

        window.NativeMethod.setAction = function (config) {
            bridge.callHandler('iOSHandler', { 'name': 'setAction', data: { name: JSON.parse(config).name } }, function (response) {});
        };

        window.NativeMethod.setTitle = function (title) {
            if (title) {
                bridge.callHandler('iOSHandler', { 'name': 'setTitle', data: { title: title } }, function (response) {});
            }
        };

        window.NativeMethod.setArea = function () {
            bridge.callHandler('iOSHandler', { 'name': 'setArea' }, function (response) {});
        };

        window.NativeMethod.goNativePath = function (path) {
            bridge.callHandler('iOSHandler', { 'name': 'goNativePath', data: { path: path } }, function (response) {});
        };

        window.NativeMethod.sensorsTrack = function (key, data) {};

        window.NativeMethod.onFinishLoad = function () {};
    });
}

function iOSMessageHandler() {
    function connectWebViewJavascriptBridge(callback) {
        callback();
    }

    connectWebViewJavascriptBridge(function () {

        if (!window.NativeMethod) {
            window.NativeMethod = {};
        }

        window.NativeMethod.wechatPay = function (data) {
            window.webkit.messageHandlers.wechatPay.postMessage({ data: JSON.parse(data) });
        };

        window.NativeMethod.openDrawer = function () {
            window.webkit.messageHandlers.openDrawer.postMessage(null);
        };

        window.NativeMethod.pushMiniProgram = function (data) {
            window.webkit.messageHandlers.pushMiniProgram.postMessage(data);
        };

        window.NativeMethod.getContacts = function () {
            window.webkit.messageHandlers.getContacts.postMessage(null);
        };

        window.NativeMethod.openMsg = function () {
            window.webkit.messageHandlers.openMsg.postMessage(null);
        };

        window.NativeMethod.completeAction = function () {
            window.webkit.messageHandlers.completeAction.postMessage(null);
        };

        window.NativeMethod.shareInfo = function (_config) {
            window.webkit.messageHandlers.shareInfo.postMessage(_config);
        };

        window.NativeMethod.setAction = function (config) {
            window.webkit.messageHandlers.setAction.postMessage({ name: JSON.parse(config).name });
        };

        window.NativeMethod.setTitle = function (title) {
            if (title) {
                window.webkit.messageHandlers.setTitle.postMessage({ title: title });
            }
        };

        window.NativeMethod.setArea = function () {
            window.webkit.messageHandlers.setArea.postMessage(null);
        };

        window.NativeMethod.goNativePath = function (path) {
            window.webkit.messageHandlers.goNativePath.postMessage({ path: path });
        };

        window.NativeMethod.savePhoto = function (url) {
            window.webkit.messageHandlers.savePhoto.postMessage({ url: url });
        };

        window.NativeMethod.sensorsTrack = function (key, data) {};

        window.NativeMethod.onFinishLoad = function () {};
    });
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(52), __esModule: true };

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(53), __esModule: true };

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(70);
__webpack_require__(46);
__webpack_require__(71);
__webpack_require__(72);
module.exports = __webpack_require__(2).Symbol;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47);
__webpack_require__(48);
module.exports = __webpack_require__(29).f('iterator');


/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(8);
var toLength = __webpack_require__(44);
var toAbsoluteIndex = __webpack_require__(68);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(17);
var gOPS = __webpack_require__(38);
var pIE = __webpack_require__(23);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(15);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(15);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(36);
var descriptor = __webpack_require__(13);
var setToStringTag = __webpack_require__(18);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(5)(IteratorPrototype, __webpack_require__(1)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(14)('meta');
var isObject = __webpack_require__(9);
var has = __webpack_require__(3);
var setDesc = __webpack_require__(6).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(10)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(31);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(6);
var anObject = __webpack_require__(7);
var getKeys = __webpack_require__(17);

module.exports = __webpack_require__(4) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(23);
var createDesc = __webpack_require__(13);
var toIObject = __webpack_require__(8);
var toPrimitive = __webpack_require__(27);
var has = __webpack_require__(3);
var IE8_DOM_DEFINE = __webpack_require__(34);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(4) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(8);
var gOPN = __webpack_require__(37).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(3);
var toObject = __webpack_require__(45);
var IE_PROTO = __webpack_require__(24)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(26);
var defined = __webpack_require__(21);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(26);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(54);
var step = __webpack_require__(60);
var Iterators = __webpack_require__(12);
var toIObject = __webpack_require__(8);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(35)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(0);
var has = __webpack_require__(3);
var DESCRIPTORS = __webpack_require__(4);
var $export = __webpack_require__(11);
var redefine = __webpack_require__(40);
var META = __webpack_require__(61).KEY;
var $fails = __webpack_require__(10);
var shared = __webpack_require__(25);
var setToStringTag = __webpack_require__(18);
var uid = __webpack_require__(14);
var wks = __webpack_require__(1);
var wksExt = __webpack_require__(29);
var wksDefine = __webpack_require__(28);
var enumKeys = __webpack_require__(56);
var isArray = __webpack_require__(58);
var anObject = __webpack_require__(7);
var toIObject = __webpack_require__(8);
var toPrimitive = __webpack_require__(27);
var createDesc = __webpack_require__(13);
var _create = __webpack_require__(36);
var gOPNExt = __webpack_require__(65);
var $GOPD = __webpack_require__(64);
var $DP = __webpack_require__(6);
var $keys = __webpack_require__(17);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(37).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(23).f = $propertyIsEnumerable;
  __webpack_require__(38).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(16)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(5)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(28)('asyncIterator');


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(28)('observable');


/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_73__;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _platform_svc = __webpack_require__(30);

var _platform_svc2 = _interopRequireDefault(_platform_svc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ANDROID_COACH_COMMENT_VERSION = '1.5.0';
var ANDROID_STAFF_COMMENT_VERSION = '0.70.0';
var ANDROID_MP_JUMP_VERSION = '1.221213';

var IOS_COACH_COMMENT_VERSION = '2.2.2';
var IOS_STAFF_COMMENT_VERSION = '2.1.1';
var IOS_COACH_MP_JUMP_VERSION = '2.7.9';
var IOS_STAFF_MP_JUMP_VERSION = '2.8.15';

function checkTargetVersion(aosCoachVersion, aosStaffVersion, iosCoachVersion, iosStaffVersion) {
  var inAndroidCoachApp = _platform_svc2.default.app === 'coach' && _platform_svc2.default.system === 'android';
  var inAndroidStaffApp = _platform_svc2.default.app === 'staff' && _platform_svc2.default.system === 'android';
  var inIOSCoachApp = _platform_svc2.default.app === 'coach' && _platform_svc2.default.system === 'iOS';
  var inIOSStaffApp = _platform_svc2.default.app === 'staff' && _platform_svc2.default.system === 'iOS';

  if (inAndroidCoachApp) {
    return !isPrevVersion(_platform_svc2.default.qcAppVersion, aosCoachVersion);
  } else if (inAndroidStaffApp) {
    return !isPrevVersion(_platform_svc2.default.qcAppVersion, aosStaffVersion);
  } else if (inIOSCoachApp) {
    return !isPrevVersion(_platform_svc2.default.qcAppVersion, iosCoachVersion);
  } else if (inIOSStaffApp) {
    return !isPrevVersion(_platform_svc2.default.qcAppVersion, iosStaffVersion);
  } else {
    return false;
  }
}

function isPrevVersion(currentVersion, targetVersion) {
  if (!targetVersion || !currentVersion) return !1;
  var currentArr = currentVersion.split('.');
  var targetArr = targetVersion.split('.');
  if (currentArr[0] !== targetArr[0]) return parseInt(currentArr[0]) < parseInt(targetArr[0]);
  if (currentArr[1] !== targetArr[1]) return parseInt(currentArr[1]) < parseInt(targetArr[1]);
  return parseInt(currentArr[2]) < parseInt(targetArr[2]);
}

exports.default = {
  checkTargetVersion: checkTargetVersion,
  checkMpJumpVersion: function checkMpJumpVersion() {
    return checkTargetVersion(ANDROID_MP_JUMP_VERSION, ANDROID_MP_JUMP_VERSION, IOS_COACH_MP_JUMP_VERSION, IOS_STAFF_MP_JUMP_VERSION);
  },
  checkCommentFeature: function checkCommentFeature() {
    var inAndroidCoachApp = _platform_svc2.default.app === 'coach' && _platform_svc2.default.system === 'android';
    var inAndroidStaffApp = _platform_svc2.default.app === 'staff' && _platform_svc2.default.system === 'android';
    var inIOSCoachApp = _platform_svc2.default.app === 'coach' && _platform_svc2.default.system === 'iOS';
    var inIOSStaffApp = _platform_svc2.default.app === 'staff' && _platform_svc2.default.system === 'iOS';

    if (inAndroidCoachApp) {
      return !this.isPrevVersion(_platform_svc2.default.qcAppVersion, ANDROID_COACH_COMMENT_VERSION);
    } else if (inAndroidStaffApp) {
      return !this.isPrevVersion(_platform_svc2.default.qcAppVersion, ANDROID_STAFF_COMMENT_VERSION);
    } else if (inIOSCoachApp) {
      return !this.isPrevVersion(_platform_svc2.default.qcAppVersion, IOS_COACH_COMMENT_VERSION);
    } else if (inIOSStaffApp) {
      return !this.isPrevVersion(_platform_svc2.default.qcAppVersion, IOS_STAFF_COMMENT_VERSION);
    } else {
      return false;
    }
  },

  isPrevVersion: isPrevVersion
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});


var wxSvc = {};

wxSvc.queue = {};

wxSvc.isReady = !!global.g_weixin_ready;

wxSvc.checkReady = function () {
  if (global.wx && global.g_weixin_ready) {
    wxSvc.isReady = global.g_weixin_ready;
    wxSvc.onReady();
  }
};

wxSvc.onReady = function () {
  wx.showOptionMenu();
  for (var key in wxSvc.queue) {
    if (wxSvc.queue[key]) wx[key](wxSvc.queue[key]);else wx[key]();
  }
};

wxSvc.addToQueue = function (key, config) {
  wxSvc.queue[key] = config;
};

wxSvc.shareTimeLine = function (config) {
  if (global.wx && global.g_weixin_ready) {
    wx.onMenuShareTimeline(config);
  } else {
    wxSvc.addToQueue('onMenuShareTimeline', config);
  }
};

wxSvc.shareAppMessage = function (config) {
  if (global.wx && global.g_weixin_ready) {
    wx.onMenuShareAppMessage(config);
  } else {
    wxSvc.addToQueue('onMenuShareAppMessage', config);
  }
};

wxSvc.closeWindow = function () {
  if (global.wx && global.g_weixin_ready) {
    wx.closeWindow();
  } else {
    wxSvc.addToQueue('closeWindow', '');
  }
};

wxSvc.getLocation = function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (global.wx && global.g_weixin_ready) {
    wx.getLocation(config);
  } else {
    wxSvc.addToQueue('getLocation', config);
  }
};

wxSvc.hideOptionMenu = function () {
  if (global.wx && global.g_weixin_ready) {
    wx.hideOptionMenu();
  } else {
    wxSvc.addToQueue('hideOptionMenu', '');
  }
};

function _checkReady() {
  if (!wxSvc.isReady) {
    wxSvc.checkReady();
    setTimeout(_checkReady, 200);
  }
}

setTimeout(_checkReady, 200);

exports.default = wxSvc;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(114)))

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(95), __esModule: true };

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(15);
var TAG = __webpack_require__(1)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var isObject = __webpack_require__(9);
var newPromiseCapability = __webpack_require__(62);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(7);
var aFunction = __webpack_require__(31);
var SPECIES = __webpack_require__(1)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(32);
var invoke = __webpack_require__(100);
var html = __webpack_require__(43);
var cel = __webpack_require__(33);
var global = __webpack_require__(0);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(15)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(76);

var _stringify2 = _interopRequireDefault(_stringify);

var _platform_svc = __webpack_require__(30);

var _platform_svc2 = _interopRequireDefault(_platform_svc);

var _wx_svc = __webpack_require__(75);

var _wx_svc2 = _interopRequireDefault(_wx_svc);

var _web_link_native_svc = __webpack_require__(49);

var _web_link_native_svc2 = _interopRequireDefault(_web_link_native_svc);

var _filters = __webpack_require__(20);

var _lodash = __webpack_require__(19);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  methods: {
    generateShareInfo: function generateShareInfo() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _config = {
        title: config.title || document.title,
        link: config.link || window.location.href,
        imgUrl: (0, _filters.imgPostfix)(config.imgUrl || (document.getElementsByTagName('img')[0] || {}).src || '', '120x120'),
        desc: config.desc || ''
      };
      if (config.extra) _config.extra = config.extra;
      return _config;
    },
    setWxShare: function setWxShare() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _config = this.generateShareInfo(config);
      _wx_svc2.default.shareTimeLine(_config);
      _wx_svc2.default.shareAppMessage(_config);
    },
    setAppShare: function setAppShare() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _self = this;
      if (_web_link_native_svc2.default.setAction) {
        _web_link_native_svc2.default.setAction({
          name: "分享",
          callback: function callback() {
            _self.goAppShare(config);
          }
        });
      }
    },
    goAppShare: function goAppShare() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _web_link_native_svc2.default.getNativeMethod().shareInfo((0, _stringify2.default)(this.generateShareInfo(config)));
    },
    setShare: function setShare() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var app = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['wx', 'coach', 'staff'];

      if (typeof app == 'string' || _lodash2.default.isArray(app) && _lodash2.default.includes(app, _platform_svc2.default.app)) {
        if (_platform_svc2.default.app == 'wx') return this.setWxShare(config);
        if (_platform_svc2.default.app == 'coach' || _platform_svc2.default.app == 'staff') return this.setAppShare(config);
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('unload', function (e) {
      if ((_platform_svc2.default.app == 'staff' || _platform_svc2.default.app == 'coach') && _web_link_native_svc2.default.setAction) {
        _web_link_native_svc2.default.setAction({
          name: '',
          callback: ''
        });
      }
    });
  }
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  install: function install(Vue, options) {
    Vue.directive('img-adjust', {
      bind: function bind(el, binding, vnode) {

        el.style.display = 'none';

        el.onload = function () {
          var _width = this.naturalWidth,
              _height = this.naturalHeight,
              _aspectRatio = _width / _height,
              _offsetParent = this.parentNode,
              _parentWidth = _offsetParent.clientWidth,
              _parentHeight = _offsetParent.clientHeight,
              _parentAspectRatio = _parentWidth / _parentHeight;

          if (_aspectRatio < _parentAspectRatio) {
            this.style.cssText += ";position:absolute;width:100%;height:auto;left:0;top:50%;margin-left:0;margin-top:" + -1 * (_parentWidth / _width) * _height * 0.5 + 'px';
            this.style.display = '';
          } else if (_aspectRatio > _parentAspectRatio) {
            this.style.cssText += ";position:absolute;width:auto;height:100%;top:0;left:50%;margin-top:0;margin-left:" + -1 * (_parentHeight / _height) * _width * 0.5 + 'px';
            this.style.display = '';
          } else {
            this.style.display = '';
          }
        };
      },
      update: function update() {},
      unbind: function unbind() {}
    });
  }
};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(19);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  install: function install(Vue) {
    function assign(vnode, name) {
      if (!name) return console.error('Directive need name');

      var model = _lodash2.default.find(vnode.data.directives, { name: 'model' });
      if (!model) return console.error('Directive need v-model');

      if (!vnode.context.validators) vnode.context.validators = {};
      var validators = vnode.context.validators;
      if (!validators[name]) Vue.set(validators, name, {});
      if (!validators[name].$errors) Vue.set(validators[name], '$errors', {});
      return !0;
    }

    function getModelValue(vnode) {
      return (_lodash2.default.find(vnode.data.directives, { name: 'model' }) || {}).value;
    }

    function getValid(validators, name) {
      return !_lodash2.default.includes(validators[name].$errors, !0);
    }

    var PHONE_PATTERN = /^1\d{10}$/;
    var EMAIL_PATTERN = /^\w+@(\w+\.)+\w+$/;
    var NUMBER_PATTERN = /^\d+$/;

    var rules = {
      required: function required(validators, name, model) {
        Vue.set(validators[name].$errors, 'required', !model);
      },
      pattern: function pattern(validators, name, model, value) {
        Vue.set(validators[name].$errors, 'pattern', !value.test(model));
      },
      equal: function equal(validators, name, model, value) {
        Vue.set(validators[name].$errors, 'equal', value !== model);
      },
      phone: function phone(validators, name, model) {
        Vue.set(validators[name].$errors, 'phone', !PHONE_PATTERN.test(model));
      },
      email: function email(validators, name, model) {
        Vue.set(validators[name].$errors, 'email', !EMAIL_PATTERN.test(model));
      },
      number: function number(validators, name, model, value) {
        Vue.set(validators[name].$errors, 'number', !NUMBER_PATTERN.test(model) || model < value.min || model > value.max);
      },
      length: function length(validators, name, model, value) {
        Vue.set(validators[name].$errors, 'length', model.length < value.min || model.length > value.max);
      }
    };

    Vue.directive('validate', {
      componentUpdated: function componentUpdated(el, binding, vnode) {
        var rule = binding.arg;
        var model = getModelValue(vnode);
        var name = vnode.data.attrs.name;
        var validators = vnode.context.validators;

        if (rules[rule]) {
          rules[rule](validators, name, model, binding.value);
        }

        Vue.set(validators[name], '$valid', getValid(validators, name));
      },
      bind: function bind(el, binding, vnode) {
        var name = vnode.data.attrs.name;
        if (!assign(vnode, name)) return !1;
        if (el.$blurBinder) return !0;
        el.$blurBinder = function () {
          Vue.set(vnode.context.validators[name], '$touched', !0);
        };
        el.addEventListener('blur', el.$blurBinder);
        return !0;
      },
      unbind: function unbind(el, binding, vnode) {
        el.removeEventListener('blur', el.$blurBinder);
        el.$blurBinder = null;
      }
    });
  }
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _platform_svc = __webpack_require__(30);

var _platform_svc2 = _interopRequireDefault(_platform_svc);

var _web_link_native_svc = __webpack_require__(49);

var _web_link_native_svc2 = _interopRequireDefault(_web_link_native_svc);

var _filters = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function QcAnalysis() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultPrefix = 'Fe_';
  var _defaultDevPrefix = 'Fetest_';
  var _defaultTrustedHostReg = /\.qingchengfit\.cn/;
  var _defaultTestHostReg = /(feature\d*|cloudtest)\.qingchengfit\.cn/;

  if (window.sa === undefined && _platform_svc2.default.app != 'coach' && _platform_svc2.default.app != 'staff') throw new Error('sa engine not initialed');

  if (_defaultTrustedHostReg.test(location.host) && !_defaultTestHostReg.test(location.host)) {
    this.prefix = config.prefix || _defaultPrefix;
  } else {
    this.prefix = _defaultDevPrefix;
  }

  this.saEngine = window.sa;

  this.trackIdentity = 'saTrack';
  this.errorEvent = 'error';
  this.defaultEvent = 'anonymous_event';

  this.customDataPrefix = 'data-track-';

  this.initTime = new Date();
  this.config = config;
}

QcAnalysis.prototype.init = function () {
  var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  this.initPageEvents(extra);
  this.initClickTrack(extra);
};

QcAnalysis.prototype.initClickTrack = function () {
  var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _self = this;

  function getAttributeNode(el, attr) {
    if (el.hasAttribute && el.hasAttribute(attr)) {
      return el;
    } else {
      return el !== document && el.parentNode ? getAttributeNode(el.parentNode, attr) : null;
    }
  }

  function eventBinder(event) {
    var _el = getAttributeNode(event.srcElement || event.target, 'data-action');

    if (!_el) return;

    var _action = _el.getAttribute('data-action'),
        _event = _el.getAttribute('data-event');

    if (_action === _self.trackIdentity) {
      var data = {
        qc_page_url: location.href,
        qc_referrer_url: document.referrer
      };

      var customData = _self.formatCustomData(_el);

      data = _.extend(data, extra, customData);

      _self.multiTrack(_event, data);
    }
  }

  if (_platform_svc2.default.system) {
    document.addEventListener('touchstart', eventBinder, false);
  } else {
    document.addEventListener('click', eventBinder, false);
  }
};

QcAnalysis.prototype.formatCustomData = function (el) {
  var _dataset = {};
  var _str = el.outerHTML ? el.outerHTML : el;
  _str = (_str.match(/^<[^>]+>/) || ['', ''])[0];
  var reg = new RegExp('\\s' + this.customDataPrefix + '([\\w\\-]+)=("|\')([^"\']+)\\2', 'g');
  _str.replace(reg, function (m, p1, p2, p3) {
    _dataset['qc_' + (0, _filters.middle2underline)(p1)] = p3;
    return m;
  });
  return _dataset;
};

QcAnalysis.prototype.track = function (name, params) {
  params = params || {};

  params.qc_page_url = location.href;
  params.qc_referrer_url = document.referrer;

  if (!this.saEngine) return console.error('sa engine not initialed');
  this.saEngine.track([this.prefix, name || this.defaultEvent].join(''), params);
};

QcAnalysis.prototype.multiTrack = function (name, params) {
  var inApp = _platform_svc2.default.app == 'staff' || _platform_svc2.default.app == 'coach';

  if (inApp && _web_link_native_svc2.default.sensorsTrack && _web_link_native_svc2.default.getNativeMethod().sensorsTrack) {
    _web_link_native_svc2.default.sensorsTrack([this.prefix, name || this.defaultEvent].join(''), params);
  } else {
    this.track(name, params);
  }
};

QcAnalysis.prototype.initPageEvents = function () {
  var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _self = this;
  var key, data;

  if (_self.config && _self.config.pageEvents) {

    if (_self.config.pageEvents.enter) {
      key = _self.config.pageEvents.enter;
      data = {
        qc_enter_page_at: _self.initTime.getTime()
      };
      data = _.extend(data, extra);

      _self.multiTrack(key, data);
    }

    if (_self.config.pageEvents.leave) {
      window.onbeforeunload = function () {
        var _end = new Date();
        var _duration = (_end.getTime() - _self.initTime.getTime()) / 1000;

        if (_self.config.pageEvents.leave) {
          key = _self.config.pageEvents.leave;
          data = {
            qc_leave_page_at: _end.getTime(),
            qc_page_stay_time: _duration
          };
          data = _.extend(data, extra);

          _self.multiTrack(key, data);
        }
      };
    }
  }
};

exports.default = QcAnalysis;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(94);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cookiesSvc = {};

var DEFAULT_PATH = '/';
var DEFAULT_EXPIRE = 5 * 365;

cookiesSvc.cookies = {};

cookiesSvc.getExpire = function (dates) {
  var now = new Date();
  now.setDate(now.getDate() + dates);
  return now.toUTCString();
};

cookiesSvc.setCookie = function (params) {
  var str = '';

  params.path = params.path || DEFAULT_PATH;
  params.expires = params.expires || cookiesSvc.getExpire(DEFAULT_EXPIRE);

  (0, _keys2.default)(params).forEach(function (key) {
    str += key + '=' + params[key] + '; ';
  });

  str.replace(/;\s$/, '');
  document.cookie = str;
};

cookiesSvc.getCookie = function (key) {
  var cookies = document.cookie;

  if (!cookiesSvc.cookies[key]) {
    cookies.split(/;\s*/).forEach(function (cookie) {
      if (cookie) {
        var arr = cookie.split('=');
        cookiesSvc.cookies[arr[0]] = arr[1];
      }
    });
  }

  return cookiesSvc.cookies[key] || '';
};

exports.default = cookiesSvc;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _filters = __webpack_require__(20);

var _lodash = __webpack_require__(19);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var goToSvc = {};

goToSvc.paramsReg = /\${([a-zA-Z]+)}/g;

goToSvc.path = {};

goToSvc.install = function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  this.path = _lodash2.default.extend(this.path, config);
};

goToSvc.go = function (name, params) {
  location.href = goToSvc.getUrl(name, params);
};

goToSvc.path = function (name, params) {
  location.href = goToSvc.getUrl(name, params, !0);
};

goToSvc.getUrl = function (name) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var keep = arguments[2];

  var _searchObj = (0, _filters.search2obj)(location.search);

  if (keep) {
    params = _lodash2.default.extend({}, _searchObj, params);
  } else {
    params = _lodash2.default.extend({}, params);
    !params.recommend_user_id && (params.recommend_user_id = _searchObj.recommend_user_id);
    params.activity_id = _searchObj.activity_id;
  }

  var _replacedHref = this.path[name].replace(this.paramsReg, function (s0, s1) {
    var str,
        camel = (0, _filters.camel2underline)(s1);
    if (params[s1]) {
      str = params[s1];
      delete params[s1];
    } else if (params[camel]) {
      str = params[camel];
      delete params[camel];
    }
    return str || '';
  });
  var _originParams = (0, _filters.search2obj)(_replacedHref);
  var _search = (0, _filters.obj2search)(_lodash2.default.extend(_originParams, params));

  return _replacedHref.split('?')[0] + (_search ? '?' + _search : '');
};

goToSvc.appendSearch2Url = function (url, params) {
  var _originParams = (0, _filters.search2obj)(url),
      _search = (0, _filters.obj2search)(_originParams, params);

  return url.split('?')[0] + (_search ? '?' + _search : '');
};

exports.default = goToSvc;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _platform_svc = __webpack_require__(30);

var _platform_svc2 = _interopRequireDefault(_platform_svc);

var _lodash = __webpack_require__(19);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var schemeSvc = {};

var downloadUrl = {
    coach: 'http://fir.im/sa5v',
    staff: 'http://fir.im/qcfit'
};

var schemeBase = {
    coach: 'qccoach://',
    staff: 'qcstaff://'
};

var createIframe = function () {
    var iframe;
    return function () {
        if (iframe) {
            return iframe;
        } else {
            iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
            return iframe;
        }
    };
}();

function createScheme(url, app) {
    var _base = schemeBase[app] || schemeBase['coach'];
    if (url.match(/^https?:\/\//)) {
        return _base + 'openurl/' + url.split('//')[1];
    }
    var _path = url.split('//')[1];
    return _base + (_path ? _path : url);
}

schemeSvc.openInApp = function openInApp(url, app) {
    var scheme = createScheme(url, app);
    var iframe = createIframe();
    var downloadPage = downloadUrl[app] || downloadUrl.coach;
    var start;
    if (_platform_svc2.default.app == 'chrome') {
        window.location.href = scheme;
        return doLater();
    }

    if (_platform_svc2.default.system == 'iOS' && _platform_svc2.default.iOSVersion < 9) {
        iframe.src = scheme;
        doLater();
    } else if (_platform_svc2.default.system == 'android') {
        iframe.src = scheme;
        doLater();
    } else {
        window.location.href = scheme;
        doLater();
    }

    function doLater() {
        return checkOpen(function (opened) {
            if (!opened) {
                window.location.href = downloadPage;
            }
        });
    }

    function checkOpen(cb) {
        var _clickTime = Date.now();
        function check(elsTime) {
            if (elsTime > 2500 || document.hidden || document.webkitHidden) {
                cb(1);
            } else {
                cb(0);
            }
        }

        var _count = 0,
            intHandle;
        intHandle = setInterval(function () {
            _count++;
            var elsTime = Date.now() - _clickTime;
            if (_count >= 100 || elsTime > 2500) {
                clearInterval(intHandle);
                check(elsTime);
            }
        }, 20);
    }
};

schemeSvc.goScheme = function (url, app) {
    var disabledApps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['staff', 'coach', 'wx'];

    if (!_lodash2.default.includes(disabledApps, _platform_svc2.default.app) && (!_platform_svc2.default.iOSVersion || _platform_svc2.default.iOSVersion < 9)) {
        this.openInApp(url, app);
    }
};

exports.default = schemeSvc;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(41);

var _promise2 = _interopRequireDefault(_promise);

var _exifJs = __webpack_require__(113);

var _exifJs2 = _interopRequireDefault(_exifJs);

var _lodash = __webpack_require__(19);

var _lodash2 = _interopRequireDefault(_lodash);

var _compress_svc = __webpack_require__(92);

var _compress_svc2 = _interopRequireDefault(_compress_svc);

var _ajax = __webpack_require__(93);

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _imgConfig, _rotateConfig, _hostMap;

_imgConfig = {
  bucket: "zoneke-img",
  expiration: parseInt(new Date().getTime() / 1000) + 10000,
  'save-key': '/{filemd5}{.suffix}',
  'allow-file-type': 'jpg,jpeg,png,gif',
  "content-length-range": '0,5100000'
};

_rotateConfig = {
  "1": 'auto',
  "6": '90',
  "3": '180',
  "8": '270'
};

_hostMap = {
  'qcfile': 'static.qingchengfit.cn',
  'zoneke-img': 'img.qingchengfit.cn'
};

var _config = {
  MAX_IMAGE_LENGTH: 15,
  UPYUN_URL: 'https://v0.api.upyun.com/',
  SIGNATURE_REQUEST: '/core/signature/'
};

var _fileConfig = {
  bucket: "qcfile",
  expiration: parseInt(new Date().getTime() / 1000) + 600000,
  'save-key': '/{filemd5}{.suffix}',
  'allow-file-type': 'jpg,jpeg,png,doc,docx,pdf,xls,xlsx,numbers'
};

var upyunSvc = {};

upyunSvc.setConfig = function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _config = _lodash2.default.extend(_config, config);
};

upyunSvc.getSignature = function () {
  var configCache, responseCache;
  return function (config) {
    if (_lodash2.default.isEqual(config, configCache)) {
      if (responseCache) {
        return _promise2.default.resolve(responseCache);
      } else {
        return new _promise2.default(function (resolve) {
          setTimeout(function () {
            upyunSvc.getSignature(config).then(resolve);
          }, 10);
        });
      }
    } else {
      configCache = config;
      responseCache = null;
      return _ajax2.default.get(_config.SIGNATURE_REQUEST, config).then(function (response) {
        responseCache = response;
        return response;
      });
    }
  };
}();

upyunSvc.isTypeValid = function (file) {
  var upyunConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _imgConfig;

  var supports = _lodash2.default.map(upyunConfig['allow-file-type'].split(','), function (type) {
    return 'image/' + type;
  });
  return _lodash2.default.includes(supports, file.type);
};

upyunSvc.isSizeInvalid = function (file) {
  var upyunConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _imgConfig;

  var range = upyunConfig['content-length-range'].split(',');
  var size = file.size;
  if (size < (range[0] || 0)) return -1;
  if (size > (range[1] || 0)) return 1;
};

upyunSvc.uploadImg = function (file) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var upyunConfig = arguments[2];

  var _imgCfg = _lodash2.default.extend({}, _imgConfig, upyunConfig);

  var p = new _promise2.default(function (resolve, reject) {
    if (!upyunSvc.isTypeValid(file, _imgCfg)) return reject({ message: '文件格式不对', status: "file_type_error" });

    var isSizeInvalid = upyunSvc.isSizeInvalid(file, _imgCfg);
    if (isSizeInvalid) return reject({ message: isSizeInvalid > 0 ? '文件过大' : '文件过小', status: isSizeInvalid > 0 ? "file_too_large" : "file_too_small" });

    if (typeof _exifJs2.default !== 'undefined') {
      _exifJs2.default.getData(file, function () {
        _imgCfg["x-gmkerl-rotate"] = _rotateConfig[_exifJs2.default.getTag(this, 'Orientation')] || 'auto';

        upyunSvc.getSignature(_imgCfg).then(function (response) {
          return _compress_svc2.default.compressImg(file, config).then(function (blob) {
            var fd = new FormData();
            fd.append("file", blob);
            fd.append("policy", response.data.policy);
            fd.append("signature", response.data.signature);

            _ajax2.default.post(_config.UPYUN_URL + _imgCfg.bucket, fd).then(function (response) {
              resolve("https://" + _hostMap[_imgConfig.bucket] + response.url);
            }).catch(function (response) {
              reject(response);
            });
          });
        });
      });
    }
  });

  return p;
};

upyunSvc.uploadMultiImgs = function (files) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var upyunConfig = arguments[2];

  if (!files.length) return _promise2.default.reject({ message: "上传照片不能为空", status: "file_empty" });
  if (files.length > (config.maxLength || _config.MAX_IMAGE_LENGTH)) return _promise2.default.reject({ message: '\u4E00\u6B21\u6700\u591A\u4E0A\u4F20' + (config.maxLength || _config.MAX_IMAGE_LENGTH) + '\u5F20\u7167\u7247', status: "counts_too_much", count: config.maxLength || _config.MAX_IMAGE_LENGTH });
  var fileList = Array.prototype.slice.call(files);
  var urls = [];
  var reasons = [];
  var uploadPromises = _lodash2.default.map(fileList, function (file) {
    return upyunSvc.uploadImg(file, config, upyunConfig).then(function (url) {
      urls.push(url);
      return url;
    }, function (reason) {
      reasons.push(reason);
      return reason;
    });
  });
  return _promise2.default.all(uploadPromises).then(function () {
    return { urls: urls, reasons: reasons };
  });
};

upyunSvc.uploadFile = function (file) {
  var _this = this;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var cfg = _lodash2.default.extend({}, _fileConfig, config);
  return new _promise2.default(function (resolve, reject) {
    _this.getSignature(cfg).then(function (response) {
      var fd = new FormData();
      fd.append("file", file);
      fd.append("policy", response.data.policy);
      fd.append("signature", response.data.signature);

      _ajax2.default.post(_config.UPYUN_URL + cfg.bucket, fd).then(function (res) {
        resolve('https://' + _hostMap[cfg.bucket] + res.url);
      }).catch(function (res) {
        reject(res);
      });
    });
  });
};

exports.default = upyunSvc;

/***/ }),
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CommonShareMixins = exports.ValidateDirective = exports.ImgAdjustDirective = exports.StaticFilePathFilter = exports.ProtocolFixerFilter = exports.ImgPostfixFilter = exports.Obj2searchFilter = exports.Search2objFilter = exports.NumberFilter = exports.DateFilter = exports.GoToService = exports.CheckAppVersionService = exports.CookiesService = exports.AnalysisService = exports.SchemeService = exports.UpyunService = exports.WebLinkNativeService = exports.WxService = exports.PlatformService = undefined;

var _platform_svc = __webpack_require__(30);

var _platform_svc2 = _interopRequireDefault(_platform_svc);

var _wx_svc = __webpack_require__(75);

var _wx_svc2 = _interopRequireDefault(_wx_svc);

var _web_link_native_svc = __webpack_require__(49);

var _web_link_native_svc2 = _interopRequireDefault(_web_link_native_svc);

var _upyun_svc = __webpack_require__(89);

var _upyun_svc2 = _interopRequireDefault(_upyun_svc);

var _scheme_svc = __webpack_require__(88);

var _scheme_svc2 = _interopRequireDefault(_scheme_svc);

var _analysis_svc = __webpack_require__(85);

var _analysis_svc2 = _interopRequireDefault(_analysis_svc);

var _cookies_svc = __webpack_require__(86);

var _cookies_svc2 = _interopRequireDefault(_cookies_svc);

var _go_to_svc = __webpack_require__(87);

var _go_to_svc2 = _interopRequireDefault(_go_to_svc);

var _check_app_version_svc = __webpack_require__(74);

var _check_app_version_svc2 = _interopRequireDefault(_check_app_version_svc);

var _filters = __webpack_require__(20);

var _img_adjust = __webpack_require__(83);

var _img_adjust2 = _interopRequireDefault(_img_adjust);

var _validate = __webpack_require__(84);

var _validate2 = _interopRequireDefault(_validate);

var _common_share_mixins = __webpack_require__(82);

var _common_share_mixins2 = _interopRequireDefault(_common_share_mixins);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.PlatformService = _platform_svc2.default;
exports.WxService = _wx_svc2.default;
exports.WebLinkNativeService = _web_link_native_svc2.default;
exports.UpyunService = _upyun_svc2.default;
exports.SchemeService = _scheme_svc2.default;
exports.AnalysisService = _analysis_svc2.default;
exports.CookiesService = _cookies_svc2.default;
exports.CheckAppVersionService = _check_app_version_svc2.default;
exports.GoToService = _go_to_svc2.default;
exports.DateFilter = _filters.date;
exports.NumberFilter = _filters.number;
exports.Search2objFilter = _filters.search2obj;
exports.Obj2searchFilter = _filters.obj2search;
exports.ImgPostfixFilter = _filters.imgPostfix;
exports.ProtocolFixerFilter = _filters.protocolFixer;
exports.StaticFilePathFilter = _filters.staticFilePath;
exports.ImgAdjustDirective = _img_adjust2.default;
exports.ValidateDirective = _validate2.default;
exports.CommonShareMixins = _common_share_mixins2.default;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(41);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var compressSvc = {};

var CANVASMAXPIXEL = 4000000;

var IMAGEMAXPIXEL = 1000000;

var IMAGEMAXSIZE = 200 * 1024;

var CANVASBG = '#fff';

var COMPRESSRATIO = 0.5;

compressSvc.compressImg = function (file) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var p = new _promise2.default(function (resolve, reject) {
    if (config.keepOrigin || file.size <= (config.maxSize || IMAGEMAXSIZE)) {
      return resolve(file);
    } else {
      createReader(file, function (img) {
        var basestr = getCompressData(img, config);
        var blob = transform2blob(basestr);
        resolve(blob);
      });
    }
  });
  return p;
};

function createReader(file, callback) {
  var reader = new FileReader();
  reader.onload = function () {
    var result = this.result;
    var img = new Image();
    img.src = result;
    if (img.complete) {
      callback(img);
    } else {
      img.onload = function () {
        callback(img);
      };
    }
  };
  reader.readAsDataURL(file);
}

function getCompressData(img) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var width = img.width;
  var height = img.height;

  var ratio = Math.max(Math.sqrt(width * height / CANVASMAXPIXEL), 1);
  if (ratio > 1) {
    width /= ratio;
    height /= ratio;
  }

  var canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  var ctx = canvas.getContext('2d');
  ctx.fillStyle = CANVASBG;
  ctx.fillRect(0, 0, width, height);

  var count = width * height / IMAGEMAXPIXEL;
  if (count > 1) {
    count = ~~(Math.sqrt(count) + 1);
    var nw = ~~(width / count),
        nh = ~~(height / count);
    var tCanvas = document.createElement('canvas');
    var tCtx = tCanvas.getContext('2d');
    tCanvas.width = nw;
    tCanvas.height = nh;

    for (var i = 0; i < count; i++) {
      for (var j = 0; j < count; j++) {
        tCtx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);

        ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
      }
    }
  } else {
    ctx.drawImage(img, 0, 0, width, height);
  }

  var ndata = canvas.toDataURL('image/jpeg', config.ratio || COMPRESSRATIO);
  canvas.width = canvas.height = 0;
  canvas = ctx = null;
  if (tCanvas && tCtx) {
    tCanvas.width = tCanvas.height = 0;
    tCtx = tCanvas = null;
  }
  return ndata;
}

function transform2blob(basestr, type) {
  type = type || 'image/jpeg';
  var text = window.atob(basestr.split(',')[1]);
  var buffer = new ArrayBuffer(text.length);
  var ubuffer = new Uint8Array(buffer);

  for (var i = 0; i < text.length; i++) {
    ubuffer[i] = text.charCodeAt(i);
  }

  var Builder = window.WebKitBlobBuilder || window.MozBlobBuilder;
  var blob;

  if (Builder) {
    var builder = new Builder();
    builder.append(buffer);
    blob = builder.getBlob(type);
  } else {
    blob = new window.Blob([buffer], { type: type });
  }

  return blob;
}

exports.default = compressSvc;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(41);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    init: function init() {
        if (typeof XMLHttpRequest !== 'undefined') {
            return new XMLHttpRequest();
        }
        var versions = ["MSXML2.XmlHttp.6.0", "MSXML2.XmlHttp.5.0", "MSXML2.XmlHttp.4.0", "MSXML2.XmlHttp.3.0", "MSXML2.XmlHttp.2.0", "Microsoft.XmlHttp"];

        var xhr;
        for (var i = 0; i < versions.length; i++) {
            try {
                xhr = new ActiveXObject(versions[i]);
                break;
            } catch (e) {}
        }
        return xhr;
    },
    send: function send(url, method, data) {
        var _this = this;

        var header = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

        return new _promise2.default(function (resolve, reject) {
            var xhr = _this.init();
            xhr.open(method, url, !0);
            xhr.onreadystatechange = function () {
                if (xhr.readyState == 4) {
                    resolve(JSON.parse(xhr.responseText));
                }
            };

            for (var key in header) {
                if (header.hasOwnProperty(key)) {
                    xhr.setRequestHeader(key, header[key]);
                }
            }

            xhr.send(data);
        });
    },
    get: function get(url, data, header) {
        var query = [];
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                query.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
            }
        }
        return this.send(url + (query.length ? '?' + query.join('&') : ''), 'GET', data, header);
    },
    post: function post(url, data, header) {
        return this.send(url, 'POST', data, header);
    },
    put: function put(url, data, header) {
        return this.send(url, 'PUT', data, header);
    }
};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(96), __esModule: true };

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(2);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(109);
module.exports = __webpack_require__(2).Object.keys;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46);
__webpack_require__(47);
__webpack_require__(48);
__webpack_require__(110);
__webpack_require__(111);
__webpack_require__(112);
module.exports = __webpack_require__(2).Promise;


/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(32);
var call = __webpack_require__(102);
var isArrayIter = __webpack_require__(101);
var anObject = __webpack_require__(7);
var toLength = __webpack_require__(44);
var getIterFn = __webpack_require__(108);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 100 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(12);
var ITERATOR = __webpack_require__(1)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(7);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(1)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var macrotask = __webpack_require__(81).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(15)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if (Observer) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(11);
var core = __webpack_require__(2);
var fails = __webpack_require__(10);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(5);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(0);
var core = __webpack_require__(2);
var dP = __webpack_require__(6);
var DESCRIPTORS = __webpack_require__(4);
var SPECIES = __webpack_require__(1)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(77);
var ITERATOR = __webpack_require__(1)('iterator');
var Iterators = __webpack_require__(12);
module.exports = __webpack_require__(2).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(45);
var $keys = __webpack_require__(17);

__webpack_require__(105)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(16);
var global = __webpack_require__(0);
var ctx = __webpack_require__(32);
var classof = __webpack_require__(77);
var $export = __webpack_require__(11);
var isObject = __webpack_require__(9);
var aFunction = __webpack_require__(31);
var anInstance = __webpack_require__(98);
var forOf = __webpack_require__(99);
var speciesConstructor = __webpack_require__(80);
var task = __webpack_require__(81).set;
var microtask = __webpack_require__(104)();
var newPromiseCapabilityModule = __webpack_require__(62);
var perform = __webpack_require__(78);
var promiseResolve = __webpack_require__(79);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(1)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c;
  var i = 0;
  var reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  } return true;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(106)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(18)($Promise, PROMISE);
__webpack_require__(107)(PROMISE);
Wrapper = __webpack_require__(2)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(103)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(11);
var core = __webpack_require__(2);
var global = __webpack_require__(0);
var speciesConstructor = __webpack_require__(80);
var promiseResolve = __webpack_require__(79);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(11);
var newPromiseCapability = __webpack_require__(62);
var perform = __webpack_require__(78);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function() {

    var debug = false;

    var root = this;

    var EXIF = function(obj) {
        if (obj instanceof EXIF) return obj;
        if (!(this instanceof EXIF)) return new EXIF(obj);
        this.EXIFwrapped = obj;
    };

    if (true) {
        if (typeof module !== 'undefined' && module.exports) {
            exports = module.exports = EXIF;
        }
        exports.EXIF = EXIF;
    } else {
        root.EXIF = EXIF;
    }

    var ExifTags = EXIF.Tags = {

        // version tags
        0x9000 : "ExifVersion",             // EXIF version
        0xA000 : "FlashpixVersion",         // Flashpix format version

        // colorspace tags
        0xA001 : "ColorSpace",              // Color space information tag

        // image configuration
        0xA002 : "PixelXDimension",         // Valid width of meaningful image
        0xA003 : "PixelYDimension",         // Valid height of meaningful image
        0x9101 : "ComponentsConfiguration", // Information about channels
        0x9102 : "CompressedBitsPerPixel",  // Compressed bits per pixel

        // user information
        0x927C : "MakerNote",               // Any desired information written by the manufacturer
        0x9286 : "UserComment",             // Comments by user

        // related file
        0xA004 : "RelatedSoundFile",        // Name of related sound file

        // date and time
        0x9003 : "DateTimeOriginal",        // Date and time when the original image was generated
        0x9004 : "DateTimeDigitized",       // Date and time when the image was stored digitally
        0x9290 : "SubsecTime",              // Fractions of seconds for DateTime
        0x9291 : "SubsecTimeOriginal",      // Fractions of seconds for DateTimeOriginal
        0x9292 : "SubsecTimeDigitized",     // Fractions of seconds for DateTimeDigitized

        // picture-taking conditions
        0x829A : "ExposureTime",            // Exposure time (in seconds)
        0x829D : "FNumber",                 // F number
        0x8822 : "ExposureProgram",         // Exposure program
        0x8824 : "SpectralSensitivity",     // Spectral sensitivity
        0x8827 : "ISOSpeedRatings",         // ISO speed rating
        0x8828 : "OECF",                    // Optoelectric conversion factor
        0x9201 : "ShutterSpeedValue",       // Shutter speed
        0x9202 : "ApertureValue",           // Lens aperture
        0x9203 : "BrightnessValue",         // Value of brightness
        0x9204 : "ExposureBias",            // Exposure bias
        0x9205 : "MaxApertureValue",        // Smallest F number of lens
        0x9206 : "SubjectDistance",         // Distance to subject in meters
        0x9207 : "MeteringMode",            // Metering mode
        0x9208 : "LightSource",             // Kind of light source
        0x9209 : "Flash",                   // Flash status
        0x9214 : "SubjectArea",             // Location and area of main subject
        0x920A : "FocalLength",             // Focal length of the lens in mm
        0xA20B : "FlashEnergy",             // Strobe energy in BCPS
        0xA20C : "SpatialFrequencyResponse",    //
        0xA20E : "FocalPlaneXResolution",   // Number of pixels in width direction per FocalPlaneResolutionUnit
        0xA20F : "FocalPlaneYResolution",   // Number of pixels in height direction per FocalPlaneResolutionUnit
        0xA210 : "FocalPlaneResolutionUnit",    // Unit for measuring FocalPlaneXResolution and FocalPlaneYResolution
        0xA214 : "SubjectLocation",         // Location of subject in image
        0xA215 : "ExposureIndex",           // Exposure index selected on camera
        0xA217 : "SensingMethod",           // Image sensor type
        0xA300 : "FileSource",              // Image source (3 == DSC)
        0xA301 : "SceneType",               // Scene type (1 == directly photographed)
        0xA302 : "CFAPattern",              // Color filter array geometric pattern
        0xA401 : "CustomRendered",          // Special processing
        0xA402 : "ExposureMode",            // Exposure mode
        0xA403 : "WhiteBalance",            // 1 = auto white balance, 2 = manual
        0xA404 : "DigitalZoomRation",       // Digital zoom ratio
        0xA405 : "FocalLengthIn35mmFilm",   // Equivalent foacl length assuming 35mm film camera (in mm)
        0xA406 : "SceneCaptureType",        // Type of scene
        0xA407 : "GainControl",             // Degree of overall image gain adjustment
        0xA408 : "Contrast",                // Direction of contrast processing applied by camera
        0xA409 : "Saturation",              // Direction of saturation processing applied by camera
        0xA40A : "Sharpness",               // Direction of sharpness processing applied by camera
        0xA40B : "DeviceSettingDescription",    //
        0xA40C : "SubjectDistanceRange",    // Distance to subject

        // other tags
        0xA005 : "InteroperabilityIFDPointer",
        0xA420 : "ImageUniqueID"            // Identifier assigned uniquely to each image
    };

    var TiffTags = EXIF.TiffTags = {
        0x0100 : "ImageWidth",
        0x0101 : "ImageHeight",
        0x8769 : "ExifIFDPointer",
        0x8825 : "GPSInfoIFDPointer",
        0xA005 : "InteroperabilityIFDPointer",
        0x0102 : "BitsPerSample",
        0x0103 : "Compression",
        0x0106 : "PhotometricInterpretation",
        0x0112 : "Orientation",
        0x0115 : "SamplesPerPixel",
        0x011C : "PlanarConfiguration",
        0x0212 : "YCbCrSubSampling",
        0x0213 : "YCbCrPositioning",
        0x011A : "XResolution",
        0x011B : "YResolution",
        0x0128 : "ResolutionUnit",
        0x0111 : "StripOffsets",
        0x0116 : "RowsPerStrip",
        0x0117 : "StripByteCounts",
        0x0201 : "JPEGInterchangeFormat",
        0x0202 : "JPEGInterchangeFormatLength",
        0x012D : "TransferFunction",
        0x013E : "WhitePoint",
        0x013F : "PrimaryChromaticities",
        0x0211 : "YCbCrCoefficients",
        0x0214 : "ReferenceBlackWhite",
        0x0132 : "DateTime",
        0x010E : "ImageDescription",
        0x010F : "Make",
        0x0110 : "Model",
        0x0131 : "Software",
        0x013B : "Artist",
        0x8298 : "Copyright"
    };

    var GPSTags = EXIF.GPSTags = {
        0x0000 : "GPSVersionID",
        0x0001 : "GPSLatitudeRef",
        0x0002 : "GPSLatitude",
        0x0003 : "GPSLongitudeRef",
        0x0004 : "GPSLongitude",
        0x0005 : "GPSAltitudeRef",
        0x0006 : "GPSAltitude",
        0x0007 : "GPSTimeStamp",
        0x0008 : "GPSSatellites",
        0x0009 : "GPSStatus",
        0x000A : "GPSMeasureMode",
        0x000B : "GPSDOP",
        0x000C : "GPSSpeedRef",
        0x000D : "GPSSpeed",
        0x000E : "GPSTrackRef",
        0x000F : "GPSTrack",
        0x0010 : "GPSImgDirectionRef",
        0x0011 : "GPSImgDirection",
        0x0012 : "GPSMapDatum",
        0x0013 : "GPSDestLatitudeRef",
        0x0014 : "GPSDestLatitude",
        0x0015 : "GPSDestLongitudeRef",
        0x0016 : "GPSDestLongitude",
        0x0017 : "GPSDestBearingRef",
        0x0018 : "GPSDestBearing",
        0x0019 : "GPSDestDistanceRef",
        0x001A : "GPSDestDistance",
        0x001B : "GPSProcessingMethod",
        0x001C : "GPSAreaInformation",
        0x001D : "GPSDateStamp",
        0x001E : "GPSDifferential"
    };

     // EXIF 2.3 Spec
    var IFD1Tags = EXIF.IFD1Tags = {
        0x0100: "ImageWidth",
        0x0101: "ImageHeight",
        0x0102: "BitsPerSample",
        0x0103: "Compression",
        0x0106: "PhotometricInterpretation",
        0x0111: "StripOffsets",
        0x0112: "Orientation",
        0x0115: "SamplesPerPixel",
        0x0116: "RowsPerStrip",
        0x0117: "StripByteCounts",
        0x011A: "XResolution",
        0x011B: "YResolution",
        0x011C: "PlanarConfiguration",
        0x0128: "ResolutionUnit",
        0x0201: "JpegIFOffset",    // When image format is JPEG, this value show offset to JPEG data stored.(aka "ThumbnailOffset" or "JPEGInterchangeFormat")
        0x0202: "JpegIFByteCount", // When image format is JPEG, this value shows data size of JPEG image (aka "ThumbnailLength" or "JPEGInterchangeFormatLength")
        0x0211: "YCbCrCoefficients",
        0x0212: "YCbCrSubSampling",
        0x0213: "YCbCrPositioning",
        0x0214: "ReferenceBlackWhite"
    };

    var StringValues = EXIF.StringValues = {
        ExposureProgram : {
            0 : "Not defined",
            1 : "Manual",
            2 : "Normal program",
            3 : "Aperture priority",
            4 : "Shutter priority",
            5 : "Creative program",
            6 : "Action program",
            7 : "Portrait mode",
            8 : "Landscape mode"
        },
        MeteringMode : {
            0 : "Unknown",
            1 : "Average",
            2 : "CenterWeightedAverage",
            3 : "Spot",
            4 : "MultiSpot",
            5 : "Pattern",
            6 : "Partial",
            255 : "Other"
        },
        LightSource : {
            0 : "Unknown",
            1 : "Daylight",
            2 : "Fluorescent",
            3 : "Tungsten (incandescent light)",
            4 : "Flash",
            9 : "Fine weather",
            10 : "Cloudy weather",
            11 : "Shade",
            12 : "Daylight fluorescent (D 5700 - 7100K)",
            13 : "Day white fluorescent (N 4600 - 5400K)",
            14 : "Cool white fluorescent (W 3900 - 4500K)",
            15 : "White fluorescent (WW 3200 - 3700K)",
            17 : "Standard light A",
            18 : "Standard light B",
            19 : "Standard light C",
            20 : "D55",
            21 : "D65",
            22 : "D75",
            23 : "D50",
            24 : "ISO studio tungsten",
            255 : "Other"
        },
        Flash : {
            0x0000 : "Flash did not fire",
            0x0001 : "Flash fired",
            0x0005 : "Strobe return light not detected",
            0x0007 : "Strobe return light detected",
            0x0009 : "Flash fired, compulsory flash mode",
            0x000D : "Flash fired, compulsory flash mode, return light not detected",
            0x000F : "Flash fired, compulsory flash mode, return light detected",
            0x0010 : "Flash did not fire, compulsory flash mode",
            0x0018 : "Flash did not fire, auto mode",
            0x0019 : "Flash fired, auto mode",
            0x001D : "Flash fired, auto mode, return light not detected",
            0x001F : "Flash fired, auto mode, return light detected",
            0x0020 : "No flash function",
            0x0041 : "Flash fired, red-eye reduction mode",
            0x0045 : "Flash fired, red-eye reduction mode, return light not detected",
            0x0047 : "Flash fired, red-eye reduction mode, return light detected",
            0x0049 : "Flash fired, compulsory flash mode, red-eye reduction mode",
            0x004D : "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
            0x004F : "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
            0x0059 : "Flash fired, auto mode, red-eye reduction mode",
            0x005D : "Flash fired, auto mode, return light not detected, red-eye reduction mode",
            0x005F : "Flash fired, auto mode, return light detected, red-eye reduction mode"
        },
        SensingMethod : {
            1 : "Not defined",
            2 : "One-chip color area sensor",
            3 : "Two-chip color area sensor",
            4 : "Three-chip color area sensor",
            5 : "Color sequential area sensor",
            7 : "Trilinear sensor",
            8 : "Color sequential linear sensor"
        },
        SceneCaptureType : {
            0 : "Standard",
            1 : "Landscape",
            2 : "Portrait",
            3 : "Night scene"
        },
        SceneType : {
            1 : "Directly photographed"
        },
        CustomRendered : {
            0 : "Normal process",
            1 : "Custom process"
        },
        WhiteBalance : {
            0 : "Auto white balance",
            1 : "Manual white balance"
        },
        GainControl : {
            0 : "None",
            1 : "Low gain up",
            2 : "High gain up",
            3 : "Low gain down",
            4 : "High gain down"
        },
        Contrast : {
            0 : "Normal",
            1 : "Soft",
            2 : "Hard"
        },
        Saturation : {
            0 : "Normal",
            1 : "Low saturation",
            2 : "High saturation"
        },
        Sharpness : {
            0 : "Normal",
            1 : "Soft",
            2 : "Hard"
        },
        SubjectDistanceRange : {
            0 : "Unknown",
            1 : "Macro",
            2 : "Close view",
            3 : "Distant view"
        },
        FileSource : {
            3 : "DSC"
        },

        Components : {
            0 : "",
            1 : "Y",
            2 : "Cb",
            3 : "Cr",
            4 : "R",
            5 : "G",
            6 : "B"
        }
    };

    function addEvent(element, event, handler) {
        if (element.addEventListener) {
            element.addEventListener(event, handler, false);
        } else if (element.attachEvent) {
            element.attachEvent("on" + event, handler);
        }
    }

    function imageHasData(img) {
        return !!(img.exifdata);
    }


    function base64ToArrayBuffer(base64, contentType) {
        contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
        base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
        var binary = atob(base64);
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }
        return buffer;
    }

    function objectURLToBlob(url, callback) {
        var http = new XMLHttpRequest();
        http.open("GET", url, true);
        http.responseType = "blob";
        http.onload = function(e) {
            if (this.status == 200 || this.status === 0) {
                callback(this.response);
            }
        };
        http.send();
    }

    function getImageData(img, callback) {
        function handleBinaryFile(binFile) {
            var data = findEXIFinJPEG(binFile);
            img.exifdata = data || {};
            var iptcdata = findIPTCinJPEG(binFile);
            img.iptcdata = iptcdata || {};
            if (EXIF.isXmpEnabled) {
               var xmpdata= findXMPinJPEG(binFile);
               img.xmpdata = xmpdata || {};               
            }
            if (callback) {
                callback.call(img);
            }
        }

        if (img.src) {
            if (/^data\:/i.test(img.src)) { // Data URI
                var arrayBuffer = base64ToArrayBuffer(img.src);
                handleBinaryFile(arrayBuffer);

            } else if (/^blob\:/i.test(img.src)) { // Object URL
                var fileReader = new FileReader();
                fileReader.onload = function(e) {
                    handleBinaryFile(e.target.result);
                };
                objectURLToBlob(img.src, function (blob) {
                    fileReader.readAsArrayBuffer(blob);
                });
            } else {
                var http = new XMLHttpRequest();
                http.onload = function() {
                    if (this.status == 200 || this.status === 0) {
                        handleBinaryFile(http.response);
                    } else {
                        throw "Could not load image";
                    }
                    http = null;
                };
                http.open("GET", img.src, true);
                http.responseType = "arraybuffer";
                http.send(null);
            }
        } else if (self.FileReader && (img instanceof self.Blob || img instanceof self.File)) {
            var fileReader = new FileReader();
            fileReader.onload = function(e) {
                if (debug) console.log("Got file of length " + e.target.result.byteLength);
                handleBinaryFile(e.target.result);
            };

            fileReader.readAsArrayBuffer(img);
        }
    }

    function findEXIFinJPEG(file) {
        var dataView = new DataView(file);

        if (debug) console.log("Got file of length " + file.byteLength);
        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength,
            marker;

        while (offset < length) {
            if (dataView.getUint8(offset) != 0xFF) {
                if (debug) console.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
                return false; // not a valid marker, something is wrong
            }

            marker = dataView.getUint8(offset + 1);
            if (debug) console.log(marker);

            // we could implement handling for other markers here,
            // but we're only looking for 0xFFE1 for EXIF data

            if (marker == 225) {
                if (debug) console.log("Found 0xFFE1 marker");

                return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);

                // offset += 2 + file.getShortAt(offset+2, true);

            } else {
                offset += 2 + dataView.getUint16(offset+2);
            }

        }

    }

    function findIPTCinJPEG(file) {
        var dataView = new DataView(file);

        if (debug) console.log("Got file of length " + file.byteLength);
        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength;


        var isFieldSegmentStart = function(dataView, offset){
            return (
                dataView.getUint8(offset) === 0x38 &&
                dataView.getUint8(offset+1) === 0x42 &&
                dataView.getUint8(offset+2) === 0x49 &&
                dataView.getUint8(offset+3) === 0x4D &&
                dataView.getUint8(offset+4) === 0x04 &&
                dataView.getUint8(offset+5) === 0x04
            );
        };

        while (offset < length) {

            if ( isFieldSegmentStart(dataView, offset )){

                // Get the length of the name header (which is padded to an even number of bytes)
                var nameHeaderLength = dataView.getUint8(offset+7);
                if(nameHeaderLength % 2 !== 0) nameHeaderLength += 1;
                // Check for pre photoshop 6 format
                if(nameHeaderLength === 0) {
                    // Always 4
                    nameHeaderLength = 4;
                }

                var startOffset = offset + 8 + nameHeaderLength;
                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);

                return readIPTCData(file, startOffset, sectionLength);

                break;

            }


            // Not the marker, continue searching
            offset++;

        }

    }
    var IptcFieldMap = {
        0x78 : 'caption',
        0x6E : 'credit',
        0x19 : 'keywords',
        0x37 : 'dateCreated',
        0x50 : 'byline',
        0x55 : 'bylineTitle',
        0x7A : 'captionWriter',
        0x69 : 'headline',
        0x74 : 'copyright',
        0x0F : 'category'
    };
    function readIPTCData(file, startOffset, sectionLength){
        var dataView = new DataView(file);
        var data = {};
        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
        var segmentStartPos = startOffset;
        while(segmentStartPos < startOffset+sectionLength) {
            if(dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos+1) === 0x02){
                segmentType = dataView.getUint8(segmentStartPos+2);
                if(segmentType in IptcFieldMap) {
                    dataSize = dataView.getInt16(segmentStartPos+3);
                    segmentSize = dataSize + 5;
                    fieldName = IptcFieldMap[segmentType];
                    fieldValue = getStringFromDB(dataView, segmentStartPos+5, dataSize);
                    // Check if we already stored a value with this name
                    if(data.hasOwnProperty(fieldName)) {
                        // Value already stored with this name, create multivalue field
                        if(data[fieldName] instanceof Array) {
                            data[fieldName].push(fieldValue);
                        }
                        else {
                            data[fieldName] = [data[fieldName], fieldValue];
                        }
                    }
                    else {
                        data[fieldName] = fieldValue;
                    }
                }

            }
            segmentStartPos++;
        }
        return data;
    }



    function readTags(file, tiffStart, dirStart, strings, bigEnd) {
        var entries = file.getUint16(dirStart, !bigEnd),
            tags = {},
            entryOffset, tag,
            i;

        for (i=0;i<entries;i++) {
            entryOffset = dirStart + i*12 + 2;
            tag = strings[file.getUint16(entryOffset, !bigEnd)];
            if (!tag && debug) console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
            tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
        }
        return tags;
    }


    function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
        var type = file.getUint16(entryOffset+2, !bigEnd),
            numValues = file.getUint32(entryOffset+4, !bigEnd),
            valueOffset = file.getUint32(entryOffset+8, !bigEnd) + tiffStart,
            offset,
            vals, val, n,
            numerator, denominator;

        switch (type) {
            case 1: // byte, 8-bit unsigned int
            case 7: // undefined, 8-bit byte, value depending on field
                if (numValues == 1) {
                    return file.getUint8(entryOffset + 8, !bigEnd);
                } else {
                    offset = numValues > 4 ? valueOffset : (entryOffset + 8);
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getUint8(offset + n);
                    }
                    return vals;
                }

            case 2: // ascii, 8-bit byte
                offset = numValues > 4 ? valueOffset : (entryOffset + 8);
                return getStringFromDB(file, offset, numValues-1);

            case 3: // short, 16 bit int
                if (numValues == 1) {
                    return file.getUint16(entryOffset + 8, !bigEnd);
                } else {
                    offset = numValues > 2 ? valueOffset : (entryOffset + 8);
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getUint16(offset + 2*n, !bigEnd);
                    }
                    return vals;
                }

            case 4: // long, 32 bit int
                if (numValues == 1) {
                    return file.getUint32(entryOffset + 8, !bigEnd);
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getUint32(valueOffset + 4*n, !bigEnd);
                    }
                    return vals;
                }

            case 5:    // rational = two long values, first is numerator, second is denominator
                if (numValues == 1) {
                    numerator = file.getUint32(valueOffset, !bigEnd);
                    denominator = file.getUint32(valueOffset+4, !bigEnd);
                    val = new Number(numerator / denominator);
                    val.numerator = numerator;
                    val.denominator = denominator;
                    return val;
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        numerator = file.getUint32(valueOffset + 8*n, !bigEnd);
                        denominator = file.getUint32(valueOffset+4 + 8*n, !bigEnd);
                        vals[n] = new Number(numerator / denominator);
                        vals[n].numerator = numerator;
                        vals[n].denominator = denominator;
                    }
                    return vals;
                }

            case 9: // slong, 32 bit signed int
                if (numValues == 1) {
                    return file.getInt32(entryOffset + 8, !bigEnd);
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getInt32(valueOffset + 4*n, !bigEnd);
                    }
                    return vals;
                }

            case 10: // signed rational, two slongs, first is numerator, second is denominator
                if (numValues == 1) {
                    return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset+4, !bigEnd);
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getInt32(valueOffset + 8*n, !bigEnd) / file.getInt32(valueOffset+4 + 8*n, !bigEnd);
                    }
                    return vals;
                }
        }
    }

    /**
    * Given an IFD (Image File Directory) start offset
    * returns an offset to next IFD or 0 if it's the last IFD.
    */
    function getNextIFDOffset(dataView, dirStart, bigEnd){
        //the first 2bytes means the number of directory entries contains in this IFD
        var entries = dataView.getUint16(dirStart, !bigEnd);

        // After last directory entry, there is a 4bytes of data,
        // it means an offset to next IFD.
        // If its value is '0x00000000', it means this is the last IFD and there is no linked IFD.

        return dataView.getUint32(dirStart + 2 + entries * 12, !bigEnd); // each entry is 12 bytes long
    }

    function readThumbnailImage(dataView, tiffStart, firstIFDOffset, bigEnd){
        // get the IFD1 offset
        var IFD1OffsetPointer = getNextIFDOffset(dataView, tiffStart+firstIFDOffset, bigEnd);

        if (!IFD1OffsetPointer) {
            // console.log('******** IFD1Offset is empty, image thumb not found ********');
            return {};
        }
        else if (IFD1OffsetPointer > dataView.byteLength) { // this should not happen
            // console.log('******** IFD1Offset is outside the bounds of the DataView ********');
            return {};
        }
        // console.log('*******  thumbnail IFD offset (IFD1) is: %s', IFD1OffsetPointer);

        var thumbTags = readTags(dataView, tiffStart, tiffStart + IFD1OffsetPointer, IFD1Tags, bigEnd)

        // EXIF 2.3 specification for JPEG format thumbnail

        // If the value of Compression(0x0103) Tag in IFD1 is '6', thumbnail image format is JPEG.
        // Most of Exif image uses JPEG format for thumbnail. In that case, you can get offset of thumbnail
        // by JpegIFOffset(0x0201) Tag in IFD1, size of thumbnail by JpegIFByteCount(0x0202) Tag.
        // Data format is ordinary JPEG format, starts from 0xFFD8 and ends by 0xFFD9. It seems that
        // JPEG format and 160x120pixels of size are recommended thumbnail format for Exif2.1 or later.

        if (thumbTags['Compression']) {
            // console.log('Thumbnail image found!');

            switch (thumbTags['Compression']) {
                case 6:
                    // console.log('Thumbnail image format is JPEG');
                    if (thumbTags.JpegIFOffset && thumbTags.JpegIFByteCount) {
                    // extract the thumbnail
                        var tOffset = tiffStart + thumbTags.JpegIFOffset;
                        var tLength = thumbTags.JpegIFByteCount;
                        thumbTags['blob'] = new Blob([new Uint8Array(dataView.buffer, tOffset, tLength)], {
                            type: 'image/jpeg'
                        });
                    }
                break;

            case 1:
                console.log("Thumbnail image format is TIFF, which is not implemented.");
                break;
            default:
                console.log("Unknown thumbnail image format '%s'", thumbTags['Compression']);
            }
        }
        else if (thumbTags['PhotometricInterpretation'] == 2) {
            console.log("Thumbnail image format is RGB, which is not implemented.");
        }
        return thumbTags;
    }

    function getStringFromDB(buffer, start, length) {
        var outstr = "";
        for (n = start; n < start+length; n++) {
            outstr += String.fromCharCode(buffer.getUint8(n));
        }
        return outstr;
    }

    function readEXIFData(file, start) {
        if (getStringFromDB(file, start, 4) != "Exif") {
            if (debug) console.log("Not valid EXIF data! " + getStringFromDB(file, start, 4));
            return false;
        }

        var bigEnd,
            tags, tag,
            exifData, gpsData,
            tiffOffset = start + 6;

        // test for TIFF validity and endianness
        if (file.getUint16(tiffOffset) == 0x4949) {
            bigEnd = false;
        } else if (file.getUint16(tiffOffset) == 0x4D4D) {
            bigEnd = true;
        } else {
            if (debug) console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
            return false;
        }

        if (file.getUint16(tiffOffset+2, !bigEnd) != 0x002A) {
            if (debug) console.log("Not valid TIFF data! (no 0x002A)");
            return false;
        }

        var firstIFDOffset = file.getUint32(tiffOffset+4, !bigEnd);

        if (firstIFDOffset < 0x00000008) {
            if (debug) console.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset+4, !bigEnd));
            return false;
        }

        tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);

        if (tags.ExifIFDPointer) {
            exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
            for (tag in exifData) {
                switch (tag) {
                    case "LightSource" :
                    case "Flash" :
                    case "MeteringMode" :
                    case "ExposureProgram" :
                    case "SensingMethod" :
                    case "SceneCaptureType" :
                    case "SceneType" :
                    case "CustomRendered" :
                    case "WhiteBalance" :
                    case "GainControl" :
                    case "Contrast" :
                    case "Saturation" :
                    case "Sharpness" :
                    case "SubjectDistanceRange" :
                    case "FileSource" :
                        exifData[tag] = StringValues[tag][exifData[tag]];
                        break;

                    case "ExifVersion" :
                    case "FlashpixVersion" :
                        exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
                        break;

                    case "ComponentsConfiguration" :
                        exifData[tag] =
                            StringValues.Components[exifData[tag][0]] +
                            StringValues.Components[exifData[tag][1]] +
                            StringValues.Components[exifData[tag][2]] +
                            StringValues.Components[exifData[tag][3]];
                        break;
                }
                tags[tag] = exifData[tag];
            }
        }

        if (tags.GPSInfoIFDPointer) {
            gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
            for (tag in gpsData) {
                switch (tag) {
                    case "GPSVersionID" :
                        gpsData[tag] = gpsData[tag][0] +
                            "." + gpsData[tag][1] +
                            "." + gpsData[tag][2] +
                            "." + gpsData[tag][3];
                        break;
                }
                tags[tag] = gpsData[tag];
            }
        }

        // extract thumbnail
        tags['thumbnail'] = readThumbnailImage(file, tiffOffset, firstIFDOffset, bigEnd);

        return tags;
    }

   function findXMPinJPEG(file) {

        if (!('DOMParser' in self)) {
            // console.warn('XML parsing not supported without DOMParser');
            return;
        }
        var dataView = new DataView(file);

        if (debug) console.log("Got file of length " + file.byteLength);
        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
           if (debug) console.log("Not a valid JPEG");
           return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength,
            dom = new DOMParser();

        while (offset < (length-4)) {
            if (getStringFromDB(dataView, offset, 4) == "http") {
                var startOffset = offset - 1;
                var sectionLength = dataView.getUint16(offset - 2) - 1;
                var xmpString = getStringFromDB(dataView, startOffset, sectionLength)
                var xmpEndIndex = xmpString.indexOf('xmpmeta>') + 8;
                xmpString = xmpString.substring( xmpString.indexOf( '<x:xmpmeta' ), xmpEndIndex );

                var indexOfXmp = xmpString.indexOf('x:xmpmeta') + 10
                //Many custom written programs embed xmp/xml without any namespace. Following are some of them.
                //Without these namespaces, XML is thought to be invalid by parsers
                xmpString = xmpString.slice(0, indexOfXmp)
                            + 'xmlns:Iptc4xmpCore="http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/" '
                            + 'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" '
                            + 'xmlns:tiff="http://ns.adobe.com/tiff/1.0/" '
                            + 'xmlns:plus="http://schemas.android.com/apk/lib/com.google.android.gms.plus" '
                            + 'xmlns:ext="http://www.gettyimages.com/xsltExtension/1.0" '
                            + 'xmlns:exif="http://ns.adobe.com/exif/1.0/" '
                            + 'xmlns:stEvt="http://ns.adobe.com/xap/1.0/sType/ResourceEvent#" '
                            + 'xmlns:stRef="http://ns.adobe.com/xap/1.0/sType/ResourceRef#" '
                            + 'xmlns:crs="http://ns.adobe.com/camera-raw-settings/1.0/" '
                            + 'xmlns:xapGImg="http://ns.adobe.com/xap/1.0/g/img/" '
                            + 'xmlns:Iptc4xmpExt="http://iptc.org/std/Iptc4xmpExt/2008-02-29/" '
                            + xmpString.slice(indexOfXmp)

                var domDocument = dom.parseFromString( xmpString, 'text/xml' );
                return xml2Object(domDocument);
            } else{
             offset++;
            }
        }
    }

    function xml2json(xml) {
        var json = {};
      
        if (xml.nodeType == 1) { // element node
          if (xml.attributes.length > 0) {
            json['@attributes'] = {};
            for (var j = 0; j < xml.attributes.length; j++) {
              var attribute = xml.attributes.item(j);
              json['@attributes'][attribute.nodeName] = attribute.nodeValue;
            }
          }
        } else if (xml.nodeType == 3) { // text node
          return xml.nodeValue;
        }
      
        // deal with children
        if (xml.hasChildNodes()) {
          for(var i = 0; i < xml.childNodes.length; i++) {
            var child = xml.childNodes.item(i);
            var nodeName = child.nodeName;
            if (json[nodeName] == null) {
              json[nodeName] = xml2json(child);
            } else {
              if (json[nodeName].push == null) {
                var old = json[nodeName];
                json[nodeName] = [];
                json[nodeName].push(old);
              }
              json[nodeName].push(xml2json(child));
            }
          }
        }
        
        return json;
    }

    function xml2Object(xml) {
        try {
            var obj = {};
            if (xml.children.length > 0) {
              for (var i = 0; i < xml.children.length; i++) {
                var item = xml.children.item(i);
                var attributes = item.attributes;
                for(var idx in attributes) {
                    var itemAtt = attributes[idx];
                    var dataKey = itemAtt.nodeName;
                    var dataValue = itemAtt.nodeValue;

                    if(dataKey !== undefined) {
                        obj[dataKey] = dataValue;
                    }
                }
                var nodeName = item.nodeName;

                if (typeof (obj[nodeName]) == "undefined") {
                  obj[nodeName] = xml2json(item);
                } else {
                  if (typeof (obj[nodeName].push) == "undefined") {
                    var old = obj[nodeName];

                    obj[nodeName] = [];
                    obj[nodeName].push(old);
                  }
                  obj[nodeName].push(xml2json(item));
                }
              }
            } else {
              obj = xml.textContent;
            }
            return obj;
          } catch (e) {
              console.log(e.message);
          }
    }

    EXIF.enableXmp = function() {
        EXIF.isXmpEnabled = true;
    }

    EXIF.disableXmp = function() {
        EXIF.isXmpEnabled = false;
    }

    EXIF.getData = function(img, callback) {
        if (((self.Image && img instanceof self.Image)
            || (self.HTMLImageElement && img instanceof self.HTMLImageElement))
            && !img.complete)
            return false;

        if (!imageHasData(img)) {
            getImageData(img, callback);
        } else {
            if (callback) {
                callback.call(img);
            }
        }
        return true;
    }

    EXIF.getTag = function(img, tag) {
        if (!imageHasData(img)) return;
        return img.exifdata[tag];
    }
    
    EXIF.getIptcTag = function(img, tag) {
        if (!imageHasData(img)) return;
        return img.iptcdata[tag];
    }

    EXIF.getAllTags = function(img) {
        if (!imageHasData(img)) return {};
        var a,
            data = img.exifdata,
            tags = {};
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                tags[a] = data[a];
            }
        }
        return tags;
    }
    
    EXIF.getAllIptcTags = function(img) {
        if (!imageHasData(img)) return {};
        var a,
            data = img.iptcdata,
            tags = {};
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                tags[a] = data[a];
            }
        }
        return tags;
    }

    EXIF.pretty = function(img) {
        if (!imageHasData(img)) return "";
        var a,
            data = img.exifdata,
            strPretty = "";
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                if (typeof data[a] == "object") {
                    if (data[a] instanceof Number) {
                        strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
                    } else {
                        strPretty += a + " : [" + data[a].length + " values]\r\n";
                    }
                } else {
                    strPretty += a + " : " + data[a] + "\r\n";
                }
            }
        }
        return strPretty;
    }

    EXIF.readFromBinaryFile = function(file) {
        return findEXIFinJPEG(file);
    }

    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
            return EXIF;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
}.call(this));



/***/ }),
/* 114 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ })
/******/ ]);
});


//////////////////
// WEBPACK FOOTER
// ./~/@qingcheng/Russel/dist/index.js
// module id = 1
// module chunks = 1